export const WHY_ELENTARA = [
  {
    id: "01",
    title: "One team. One vision.",
    content: "Design and engineering under one creative direction.",
  },
  {
    id: "02",
    title: "Built to perform.",
    content: "Immersive does not have to mean slow.",
  },
  {
    id: "03",
    title: "Designed for real devices.",
    content: "Desktop, mobile, touch, motion and reduced-motion experiences.",
  },
  {
    id: "04",
    title: "Idea first. Technology second.",
    content: "Technology exists to strengthen the idea, not distract from it.",
  },
  {
    id: "05",
    title: "Experimental, but purposeful.",
    content: "We explore new interaction models while keeping every experience intentional.",
  },
];

export const PROCESS = [
  {
    id: "01",
    title: "Discover",
    content: "Understand the idea, audience, objectives and constraints.",
  },
  {
    id: "02",
    title: "Define",
    content: "Shape the concept, interaction model, technology and visual direction.",
  },
  {
    id: "03",
    title: "Build",
    content: "Design, 3D, engineering and interaction come together under one creative direction.",
  },
  {
    id: "04",
    title: "Refine",
    content: "Performance, responsiveness, accessibility and visual polish.",
  },
  {
    id: "05",
    title: "Launch",
    content: "Deploy, monitor and deliver the final experience.",
  },
];

export const AUDIENCES = [
  {
    id: "01",
    title: "For Brands",
    content: "Immersive launches, digital campaigns and experiential destinations.",
  },
  {
    id: "02",
    title: "For Architecture",
    content: "Spatial visualization, WebAR and interactive environments.",
  },
  {
    id: "03",
    title: "For Technology",
    content: "Interactive products, experimental interfaces and emerging technology.",
  },
  {
    id: "04",
    title: "For Media",
    content: "Data-driven storytelling and interactive information experiences.",
  },
  {
    id: "05",
    title: "For Culture",
    content: "Digital installations, creative technology and artistic experiences.",
  },
];
